import * as React from "react";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import AppointmentPicker from "../../../appointment/AppointmentPicker";
import {Option, option} from "ts-option";
import Appointment from "../../../../model/appointment/Appointment";

interface ComponentProps {
	/**
	 * Lead identifier to look for appointments.
	 */
	leadId: string
	/**
	 * Selected appointment identifier.
	 */
	selectedAppointmentId: Option<string>
	/**
	 * On selection change.
	 * @param {Option<Appointment>} appointment
	 */
	onChange: (appointment: Option<Appointment>) => void
}

interface ReduxProps {
	/**
	 * Appointments filtered by lead.
	 */
	appointments: Option<Appointment[]>
}

type Props = ComponentProps & ReduxProps

/**
 * Lead appointment picker.
 */
class LeadAppointmentPicker extends React.PureComponent<Props, {}> {
	render() {
		return (
			<AppointmentPicker items={this.props.appointments}
							   selectedId={this.props.selectedAppointmentId}
							   onChanged={this.props.onChange}
							   clearable={true}/>
		);
	}
}

const mapStateToProps = (state: RootState, props: ComponentProps) => {
	return {
		appointments: option(state.appointment.appointments[props.leadId])
	}
};

export default connect<ReduxProps, null, ComponentProps>(mapStateToProps)(LeadAppointmentPicker);